<!--FDC场景管理-->
<template>
  <div class="home-main fdcSceneManage">
    <div class="main" v-loading="loading">
      <div class="main_title">
        <span class="title-cn">安捷智用场景管理</span>
        <span class="title-en">/Agilework Scene Management</span>
        <div class="main-title-right">
          <el-button size="medium" class="primary" @click="openAddDialog">添加场景</el-button>
        </div>
      </div>

      <!--筛选部分start-->
      <div class="myOrder-selector">
        <div class="select-item">
          <p>场景名称</p>
          <el-input v-model="searchName" placeholder="请输入场景名称" class="select-input" size="small" clearable></el-input>
        </div>
        <el-button size="small" class="warning" @click="search">搜索</el-button>
        <el-button size="small" @click="resetSearch">重置</el-button>
      </div>
      <!--筛选部分end-->

      <div class="myOrder-main-line"></div>

      <!--列表start-->
      <div class="myOrder-main-list">
        <el-table height="100%" :data="sceneList" style="width: 100%;" stripe>
          <el-table-column width="40"></el-table-column>
          <!-- <el-table-column prop="id" label="ID" width="60"></el-table-column> -->
          <el-table-column prop="name" label="场景名称" width="150"></el-table-column>
          <el-table-column prop="description" label="场景描述"></el-table-column>
          <el-table-column label="模块" width="250">
            <template slot-scope="scope">
              <span>{{ getModuleNames(scope.row.modules) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="bi_users" label="工作用户数" width="100"></el-table-column>
          <el-table-column prop="std_users" label="查看用户数" width="100"></el-table-column>
          <!-- <el-table-column prop="sort" label="排序" width="60"></el-table-column> -->
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="openEditDialog(scope.row)">编辑</el-button>
              <el-button size="mini" type="primary" @click="deleteScene(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--列表end-->

      <div class="pagination">
        <el-pagination :disabled="!pagination.use" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pagination.currentPage" :page-sizes="[20, 30, 50, 100]" :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
        </el-pagination>
      </div>

      <!--弹窗-->
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="560px" class="editCustomerDialog">
        <el-form ref="sceneForm" :model="form" :rules="formRules" label-width="100px">
          <el-form-item label="场景名称" prop="name">
            <el-input v-model="form.name" placeholder="如：决策智能场景"></el-input>
          </el-form-item>
          <el-form-item label="场景描述" prop="description">
            <el-input type="textarea" :rows="3" v-model="form.description" placeholder="场景说明"></el-input>
          </el-form-item>
          <el-form-item label="选择模块" prop="modules">
            <el-checkbox-group v-model="form.modules">
              <el-checkbox v-for="item in modulesList" :key="item.code" :label="item.code">{{ item.name }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="工作用户数">
            <el-input-number v-model="form.bi_users" :min="0" size="small"></el-input-number>
          </el-form-item>
          <el-form-item label="查看用户数">
            <el-input-number v-model="form.std_users" :min="0" size="small"></el-input-number>
          </el-form-item>
          <!-- <el-form-item label="排序">
            <el-input-number v-model="form.sort" :min="1" size="small"></el-input-number>
          </el-form-item> -->
        </el-form>
        <div slot="footer" class="dialog-footer" style="justify-content: flex-end;">
          <el-button class="primary" @click="save('sceneForm')">保存</el-button>
          <el-button @click="closeDialog">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getFDCModulesList, getFDCScenes, createFDCScene, updateFDCScene, deleteFDCScene } from '@/api/afFdc';
import { createGetUrlParams } from '@/utils/url';

export default {
  data() {
    return {
      loading: false,
      modulesList: [],
      sceneList: [],
      searchName: '',
      pagination: {
        use: true,
        total: 0,
        size: 20,
        currentPage: 1,
      },
      dialogVisible: false,
      dialogTitle: '添加场景',
      mode: 'add',
      editId: null,
      form: {
        name: '',
        description: '',
        modules: [],
        bi_users: 0,
        std_users: 0,
        sort: 1,
      },
      formRules: {
        name: [{ required: true, message: '请输入场景名称', trigger: 'blur' }],
        modules: [{ type: 'array', required: true, message: '请选择模块', trigger: 'change' }],
      },
    };
  },
  mounted() {
    this.getModules();
    this.getSceneData();
  },
  methods: {
    getModules() {
      getFDCModulesList().then(res => {
        this.modulesList = res || [];
      });
    },
    getSceneData() {
      this.loading = true;
      let params = {
        p: this.pagination.currentPage,
        count: this.pagination.size,
        name: this.searchName,
      };
      let result = createGetUrlParams(params);
      if (result.success) {
        getFDCScenes(result.data).then(res => {
          if (Array.isArray(res)) {
            // 未分页格式（后端未重启时兼容）
            this.sceneList = res;
            this.pagination.total = res.length;
          } else {
            // 分页格式
            this.sceneList = res.results || [];
            this.pagination.total = res.count || 0;
          }
          this.loading = false;
        }).catch(() => { this.loading = false; });
      }
    },
    getModuleNames(codes) {
      if (!codes) return '';
      return codes.map(c => {
        const m = this.modulesList.find(i => i.code === c);
        return m ? m.name : c;
      }).join('、');
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getSceneData();
    },
    handleSizeChange(val) {
      this.pagination.size = val;
      this.getSceneData();
    },
    search() {
      this.restPage(true);
      this.getSceneData();
    },
    resetSearch() {
      this.searchName = '';
      this.restPage(true);
      this.getSceneData();
    },
    restPage(isUsePagination) {
      this.pagination.use = isUsePagination;
      this.pagination.currentPage = 1;
      this.pagination.size = 20;
    },
    openAddDialog() {
      this.mode = 'add';
      this.dialogTitle = '添加场景';
      this.editId = null;
      this.form = { name: '', description: '', modules: [], bi_users: 0, std_users: 0, sort: 1 };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.sceneForm && this.$refs.sceneForm.clearValidate();
      });
    },
    openEditDialog(row) {
      this.mode = 'edit';
      this.dialogTitle = '编辑场景';
      this.editId = row.id;
      this.form = {
        name: row.name,
        description: row.description,
        modules: row.modules ? [...row.modules] : [],
        bi_users: row.bi_users,
        std_users: row.std_users,
        sort: row.sort,
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.sceneForm && this.$refs.sceneForm.clearValidate();
      });
    },
    closeDialog() {
      this.dialogVisible = false;
      this.editId = null;
    },
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) return false;
        const fn = this.mode === 'add' ? createFDCScene(this.form) : updateFDCScene(this.editId, this.form);
        fn.then(() => {
          const msg = this.mode === 'add' ? '添加成功' : '编辑成功';
          this.$message.success(msg);
          this.getSceneData();
          this.closeDialog();
        }).catch(() => {});
      });
    },
    deleteScene(row) {
      this.$confirm('确定删除该场景？', '提示', { type: 'warning' }).then(() => {
        deleteFDCScene(row.id).then(() => {
          this.$message.success('删除成功');
          this.getSceneData();
        });
      }).catch(() => {});
    },
  },
};
</script>

<style lang="scss">
.fdcSceneManage {
  .main {
    display: flex;
    flex-direction: column;
    margin: 0px 14px;
    height: 100%;
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;

    .main_title {
      margin: 15px 0;
    }

    .main-title-right {
      float: right !important;
      width: 160px !important;
      height: 66px !important;
      line-height: 66px !important;
    }

    .myOrder-main-list {
      flex-grow: 1;
    }
  }

  .myOrder-main-list .cell .el-button {
    border: 0px !important;
    background-color: rgba(64, 158, 255, 0) !important;
    margin-left: 0px !important;
    padding: 2px 5px !important;
  }

  .myOrder-main-list .cell .el-button span {
    color: #0090ee !important;
  }

  .myOrder-selector {
    padding: 18px 0px 20px 24px !important;
    min-width: 980px !important;
    font-size: 12px !important;
    height: 32px !important;
    background: #fff;
  }

  .select-item {
    float: left !important;
    margin-right: 34px !important;
  }

  .select-item .el-date-editor {
    width: 180px !important;
  }

  .select-item .el-input__inner {
    padding-right: 0px !important;
  }

  .select-item p {
    padding-right: 10px !important;
    float: left !important;
    height: 32px !important;
    line-height: 32px !important;
    text-align: right !important;
  }

  .select-input {
    float: left !important;
    width: 180px !important;
  }

  .selcet-myOrder .el-input__inner {
    width: 150px !important;
    height: 32px !important;
    line-height: 32px !important;
  }

  .el-select-dropdown__list {
    padding: 6px 0px 22px 0px !important;
  }

  .el-select-dropdown span {
    font-size: 12px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/agileFlow/fdcSceneManage.vue